<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >许可列表
            <span v-if="isShowEditRow"
                >—— 许可总数量：共{{ licenseInfo.AllCount }} 已使用{{
                    licenseInfo.UsedCount
                }}
                剩余<span style="color: red; font-weight: bold; font-size: 14px"
                    >{{ licenseInfo.RemainCount }}
                </span>
                动态可分配许可：共{{ licenseInfo.AllCount2 }} 已使用{{
                    licenseInfo.UsedCount2
                }}
                剩余<span
                    style="color: red; font-weight: bold; font-size: 14px"
                    >{{ licenseInfo.RemainCount2 }}</span
                >
            </span>
            <span v-else
                >—— 动态可分配许可：共{{ licenseInfo.AllCount2 }} 已使用{{
                    licenseInfo.UsedCount2
                }}
                剩余<span
                    style="color: red; font-weight: bold; font-size: 14px"
                    >{{ licenseInfo.RemainCount2 }}</span
                ></span
            >
        </va-card-title>
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item title="状态" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    style="width: 90px"
                                    v-model="data.status"
                                    placeholder="全部"
                                    clearable
                                >
                                    <vxe-option
                                        value="0"
                                        label="未提交"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="已通过"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="许可状态" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.licenseStatus"
                                    placeholder="全部"
                                    clearable
                                    style="width: 90px"
                                >
                                    <vxe-option
                                        value="未生效"
                                        label="未生效"
                                    ></vxe-option>
                                    <vxe-option
                                        value="生效中"
                                        label="生效中"
                                    ></vxe-option>
                                    <vxe-option
                                        value="已停用"
                                        label="已停用"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    placeholder="请输入业务人员姓名或邮箱,流程ID或名称"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findData"
                                    @keyup.enter="findData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                                <vxe-button @click="addLicense" status="success"
                                    >新增</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        stripe
                        class="mytable-scrollbar"
                        :data="tableData"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                        ref="xTable"
                    >
                        <vxe-column
                            type="seq"
                            field="Id"
                            title="序号"
                            width="60"
                        ></vxe-column>
                        <vxe-column title="编辑" width="60" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-edit"
                                    @click="editEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column title="删除" width="60" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-trash-o"
                                    @click="removeEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            title="停用"
                            width="60"
                            show-overflow
                            :visible="isShowEditRow"
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-stop-circle-o"
                                    @click="stopEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column title="显示许可" width="120" align="center">
                            <template #default="{ row }">
                                <vxe-button
                                    icon="vxe-icon-search"
                                    @click="showEvent(row)"
                                    title="点击查看账号密码"
                                    status="success"
                                    content="查看许可"
                                    size="mini"
                                    round
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column align="center" title="状态" width="100">
                            <template #default="{ row }">
                                <vxe-button
                                    v-bind:class="{
                                        active: row.statusName === '已通过',
                                        error: row.statusName === '已驳回',
                                    }"
                                    type="text"
                                    @click="showAuditList(row)"
                                    >{{ row.statusName }}
                                </vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="licenseStatus"
                            title="许可状态"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="userName"
                            title="姓名"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="emailEx"
                            title="邮箱"
                            width="180"
                            sortable
                            resizable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="jobNumber"
                            title="工号"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="headQuarter"
                            title="总部（英文代码）"
                            width="160"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="dept"
                            title="部门（英文代码）"
                            width="160"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="office"
                            title="科室"
                            width="100"
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="planFinishTime"
                            title="预计完成开发时间"
                            width="160"
                        ></vxe-column>
                        <vxe-column
                            field="licenseStartTime"
                            title="许可启用时间"
                            width="140"
                            show-overflow
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="licenseEndTime"
                            title="许可停用时间"
                            width="140"
                            show-overflow
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="requireNo"
                            title="需求编号"
                            show-overflow
                            width="120"
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="processName"
                            title="RPA流程名称"
                            width="200"
                            show-overflow
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="singleTimeUse"
                            title="流程单次耗时(小时)"
                            width="180"
                        ></vxe-column>
                        <vxe-column
                            field="frequency"
                            title="流程执行频次（N次/每月）"
                            width="200"
                        ></vxe-column>
                        <vxe-column
                            field="participate"
                            title="流单次参与人员"
                            width="140"
                        ></vxe-column>
                        <vxe-column
                            field="yearTimeUse"
                            title="全年预计耗时(小时/年)"
                            width="200"
                        ></vxe-column>
                        <vxe-column
                            field="creationTime"
                            title="创建时间"
                            width="120"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="stopReason"
                            title="停用原因"
                            width="120"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="RPAUser"
                            title="RPAUser"
                            width="120"
                            :visible="false"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="RPAPwd"
                            title="RPAPwd"
                            width="120"
                            :visible="false"
                            show-overflow
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="handlePageChange"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>
            <!-- 新增-->
            <vxe-modal
                v-model="formInput.isShow"
                @close="closeWinEvent"
                :title="formInput.title"
                width="900"
                height="600"
                show-zoom
                resize
                remember
            >
                <template #default>
                    <vxe-form
                        :data="formInput.formData"
                        :rules="formInput.formRules"
                        title-align="right"
                        ref="rForm"
                        title-width="60"
                    >
                        <vxe-form-item
                            title="基本信息"
                            span="24"
                            title-align="left"
                            title-width="200px"
                            :title-prefix="{ icon: 'fa fa-address-card-o' }"
                        ></vxe-form-item>
                        <vxe-form-item
                            title="姓名"
                            field="userName"
                            span="12"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.userName"
                                    placeholder="请输入姓名"
                                    :disabled="formInput.allInputDisable"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="邮箱"
                            field="emailEx"
                            span="12"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.emailEx"
                                    placeholder="请输入邮箱"
                                    readonly
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="工号"
                            field="jobNumber"
                            span="12"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.jobNumber"
                                    placeholder="请输入工号"
                                    clearable
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="总部(英文代码)"
                            field="headQuarter"
                            span="12"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.headQuarter"
                                    readonly
                                    placeholder="请输入总部(英文代码)"
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="部门(英文代码)"
                            field="dept"
                            span="12"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.dept"
                                    readonly
                                    placeholder="请输入部门(英文代码)"
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="科室"
                            field="office"
                            span="12"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.office"
                                    placeholder="请输入科室"
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="需求编号"
                            field="requireNo"
                            span="10"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.requireNo"
                                    readonly
                                    placeholder="请选择需求编号"
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default>
                                <vxe-button
                                    @click="selectReqs()"
                                    :disabled="formInput.allInputDisable"
                                    >选择</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="预计完成开发时间"
                            field="applyMonth"
                            span="12"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.applyMonth"
                                    placeholder="请选择预计完成开发时间"
                                    clearable
                                    :disabled="formInput.allInputDisable"
                                >
                                    <vxe-option
                                        value="1"
                                        label="1个月"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="2个月"
                                    ></vxe-option>
                                    <vxe-option
                                        value="3"
                                        label="3个月"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="RPA流程名称"
                            field="processName"
                            span="24"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.processName"
                                    readonly
                                    placeholder="请输入RPA流程名称"
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="流程单次耗时(小时)"
                            field="singleTimeUse"
                            span="12"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    v-model="formInput.formData.singleTimeUse"
                                    placeholder="请输入流程单次耗时(小时)"
                                    :disabled="formInput.allInputDisable"
                                    min="0"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="流程执行频次(N次/每月)"
                            field="frequency"
                            span="12"
                            title-width="180px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.frequency"
                                    placeholder="请输入流程执行频次"
                                    clearable
                                    :disabled="formInput.allInputDisable"
                                    type="number"
                                    min="0"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="单次参与人员"
                            field="participate"
                            span="12"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.participate"
                                    placeholder="请输入单次参与人员"
                                    clearable
                                    :disabled="formInput.allInputDisable"
                                    type="number"
                                    min="0"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="全年预计耗时(小时/年)"
                            field="yearTimeUse"
                            span="12"
                            title-width="180px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.yearTimeUse"
                                    placeholder="请输入全年预计耗时"
                                    :disabled="formInput.allInputDisable"
                                    type="number"
                                    min="0"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="直属领导"
                            field="leader"
                            span="12"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.leader"
                                    placeholder="请输入直属领导"
                                    clearable
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="领导邮箱"
                            field="leaderEmail"
                            span="12"
                            title-width="180px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.leaderEmail"
                                    placeholder="请输入领导邮箱"
                                    clearable
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            align="center"
                            span="24"
                            style="position: absolute; bottom: 0"
                        >
                            <template #default>
                                <vxe-button
                                    :disabled="formInput.saveButDisable"
                                    @click="save"
                                    icon="fa fa-save"
                                    status="success"
                                    >保存
                                </vxe-button>
                                <vxe-button
                                    @click="submit"
                                    icon="fa fa-check"
                                    :disabled="formInput.saveButDisable"
                                    status="primary"
                                    :loading="submitLoading"
                                    >提交
                                </vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </template>
            </vxe-modal>
            <vxe-modal
                title="审核记录"
                v-model="isShowAuditList"
                width="500"
                height="600"
            >
                <template #default>
                    <div>
                        <MyAuditLine :auditrecord-list="dtAudit"></MyAuditLine>
                    </div>
                </template>
            </vxe-modal>
            <vxe-modal title="选择需求" v-model="isShowRequireSel" width="640">
                <template #default>
                    <div>
                        <vxe-form :data="reqTablePager">
                            <vxe-form-item
                                title="关键字"
                                field="searchKey"
                                :item-render="{}"
                            >
                                <template #default="{ data }">
                                    <vxe-input
                                        v-model="data.searchKey"
                                        placeholder="请输入需求编号、流程ID、流程名称"
                                        clearable
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item>
                                <template #default>
                                    <vxe-button
                                        @click="findReqsData"
                                        @keyup.enter="findReqsData"
                                        >查询</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                            <vxe-form-item>
                                <template #default>
                                    <vxe-button
                                        status="primary"
                                        @click="confirmSelectReq"
                                        >选择</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                        </vxe-form>
                    </div>
                    <div>
                        <vxe-table
                            class="mytable-scrollbar"
                            :data="dtReqs"
                            ref="xTableReqs"
                            height="300"
                            @cell-dblclick="confirmSelectReq"
                            highlight-hover-row
                            highlight-current-row
                        >
                            <vxe-column
                                type="seq"
                                field="Id"
                                title="序号"
                                width="50"
                            ></vxe-column>
                            <vxe-column
                                field="requireNo"
                                title="需求编号"
                                width="140"
                                sortable
                                show-overflow
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="processName"
                                title="流程名称"
                                width="180"
                                show-overflow
                                resizable
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="processID"
                                title="流程ID"
                                width="120"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="processDesc"
                                title="流程描述"
                                width="200"
                                show-overflow
                                resizable
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="bussName"
                                title="业务姓名"
                                width="120"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="divison"
                                title="总部"
                                width="100"
                                sortable
                                show-overflow
                            ></vxe-column>
                            <vxe-column
                                field="dept"
                                title="业务部门"
                                width="120"
                                resizable
                                sortable
                                show-overflow
                            ></vxe-column>
                            <vxe-column
                                field="office"
                                title="业务科室"
                                width="120"
                                sortable
                                show-overflow
                            ></vxe-column>
                            <vxe-column
                                field="winMan"
                                title="业务窗口"
                                width="100"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="leader"
                                title="业务科长"
                                width="100"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="leaderEmail"
                                title="科长邮箱"
                                width="100"
                                show-overflow
                            ></vxe-column>
                            <vxe-column
                                field="manSingleTime"
                                title="人工单次耗时"
                                width="180"
                                show-overflow
                            ></vxe-column>
                            <vxe-column
                                field="participantNum"
                                title="人工单次参与人数"
                                width="180"
                                show-overflow
                            ></vxe-column>
                            <vxe-column
                                field="manFrequency"
                                title="人工执行频次"
                                width="180"
                                show-overflow
                            ></vxe-column>
                            <vxe-column
                                field="manYear"
                                title="人工年度耗时"
                                width="180"
                                show-overflow
                            ></vxe-column>
                        </vxe-table>
                    </div>
                    <div>
                        <vxe-pager
                            background
                            v-model:current-page="reqTablePager.currentPage"
                            v-model:page-size="reqTablePager.pageSize"
                            :total="reqTablePager.totalResult"
                            @page-change="reqListPageChange"
                            size="small"
                        >
                        </vxe-pager>
                    </div>
                </template>
            </vxe-modal>
            <vxe-modal
                title="许可账号"
                v-model="licenseDetail.isShow"
                width="600"
                mask-closable
            >
                <template #default>
                    <div>
                        <vxe-form :data="licenseDetail">
                            <vxe-form-item
                                title="许可账号"
                                field="RPAUser"
                                span="11"
                                title-width="80px"
                                title-align="right"
                            >
                                <template #default>
                                    <vxe-input
                                        v-model="licenseDetail.RPAUser"
                                        readonly
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item span="1">
                                <template #default>
                                    <vxe-button
                                        type="text"
                                        icon="vxe-icon-copy"
                                        title="复制账号"
                                        @click="copyUser"
                                    ></vxe-button>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="许可密码"
                                field="RPAPwd"
                                span="11"
                                title-width="80px"
                                title-align="right"
                            >
                                <template #default>
                                    <vxe-input
                                        v-model="licenseDetail.RPAPwd"
                                        readonly
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item span="1">
                                <template #default>
                                    <vxe-button
                                        type="text"
                                        icon="vxe-icon-copy"
                                        title="复制密码"
                                        @click="copyPwd"
                                    ></vxe-button>
                                </template>
                            </vxe-form-item>
                        </vxe-form>
                    </div>
                </template>
            </vxe-modal>
            <vxe-modal
                v-model="showPopup"
                title="提示"
                show-footer
                show-confirm-button
                show-maximize
                height="350"
                width="600"
            >
                <!-- ⭐ 这里直接写 HTML，包括可点击链接 -->
                <div style="padding: 10px; line-height: 1.8; font-size: 14px">
                    由于公司预算削减，目前已<span
                        style="color: red; font-weight: bold"
                        >暂停UiPath开发许可申请</span
                    >。<br /><br />若需UiPath开发许可调整流程，请联系 CoE
                    管理员：【平智杰 ls2020-097@dfl.com.cn】<br /><br />

                    新需求提报及上岗<span style="color: red; font-weight: bold"
                        >只能使用</span
                    >东风日产自主研发的 RPA 套件<span
                        style="color: red; font-weight: bold"
                        >【派神易】</span
                    >。<br /><br />
                    派神易的安装与使用指引请参考：
                    <a
                        href="https://coe.dongfeng-nissan.com.cn/admin/forum/postsPage/postsContent?searcharticle=1487"
                        target="_blank"
                        style="color: #409eff; text-decoration: underline"
                    >
                        点击这里
                    </a>
                    <br />
                </div>
            </vxe-modal>
        </va-card-content>
    </va-card>
</template>

<script>
import Qs from "qs";
import { reactive, ref } from "vue";
import { VxeTablePropTypes } from "vxe-table";
import { VXETable } from "vxe-table";
import XEUtils from "xe-utils";
import MyAuditLine from "../myPlug/MyAuditLine";

export default {
    name: "LicenseList",
    components: { MyAuditLine },
    data() {
        const pageHeight = window.innerHeight - (65 + 48 + 200) + "px"; //屏幕高度减去导航栏和内补白
        const tablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });
        const toolbar = reactive({
            loading: false,
            statusOptions: [],
            formData: {
                searchKey: "",
                licenseStatus: "",
                applyType: "",
                status: "",
            },
        });
        const reqTablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
            searchKey: "",
        });

        const licenseDetail = reactive({
            RPAUser: "",
            RPAPwd: "",
            isShow: false,
        });

        const formInput = reactive({
            title: "许可申请",
            isShow: false,
            saveButDisable: false,
            allInputDisable: false,
            readOnly: true,
            formData: {
                Id: "",
                userName: "",
                emailEx: "",
                jobNumber: "",
                headQuarter: "", //总部
                dept: "", //部门
                office: "", //科室
                flowName: "",
                planFinishTime: "",
                applyMonth: "",
                sceneDesc: "",
                singleTimeUse: "",
                frequency: "",
                participate: "",
                yearTimeUse: "",
                leader: "",
                leaderEmail: "",
                status: "",
                applyType: "", // 1首次申请 2延期申请
                requireNo: "",
                ReqID: "",
                processName: "",
            },
            formRules: {
                userName: [{ required: true, message: "姓名不能为空" }],
                emailEx: [{ required: true, message: "邮箱不能为空" }],
                jobNumber: [{ required: true, message: "工号不能为空" }],
                headQuarter: [
                    { required: true, message: "总部(英文代码)不能为空" },
                ],
                dept: [{ required: true, message: "部门(英文代码)不能为空" }],
                office: [{ required: true, message: "科室不能为空" }],
                flowName: [
                    { required: true, message: "待开发的RPA流程名称不能为空" },
                ],
                applyMonth: [
                    { required: true, message: "预计完成开发时间不能为空" },
                ],
                sceneDesc: [{ required: true, message: "RPA场景描述不能为空" }],
                singleTimeUse: [
                    { required: false, message: "流程单次耗时(小时)不能为空" },
                ],
                frequency: [
                    {
                        required: false,
                        message: "流程执行频次(N次/每月)不能为空",
                    },
                ],
                participate: [
                    { required: false, message: "单次参与人员不能为空" },
                ],
                yearTimeUse: [
                    {
                        required: false,
                        message: "全年预计耗时(小时/年)不能为空",
                    },
                ],
                leader: [{ required: true, message: "直属领导不能为空" }],
                leaderEmail: [{ required: true, message: "领导邮箱不能为空" }],
                requireNo: [{ required: true, message: "需求编号不能为空" }],
                processName: [
                    { required: true, message: "RPA流程名称不能为空" },
                ],
            },
        });

        const licenseInfo = reactive({
            AllCount: 0,
            UsedCount: 0,
            RemainCount: 0,
            AllCount2: 0,
            UsedCount2: 0,
            RemainCount2: 0,
        });

        return {
            tableData: null,
            tablePager,
            toolbar,
            formInput,
            pageHeight,
            editType: "1", //1 新增 2 修改
            submitLoading: false,
            dtAudit: [],
            isShowAuditList: false,
            isShowEditRow: false,
            tableHeight: 0,
            isShowRequireSel: false, //发布申请，选择需求
            reqTablePager,
            dtReqs: [], //需求列表
            licenseInfo,
            licenseDetail,
            publishCount: 0,
            showPopup: false,
        };
    },
    methods: {
        launchToast(toastMsg) {
            this.$vaToast.init({
                message: toastMsg,
                iconClass: this.toastIcon,
                position: this.toastPosition,
                duration: Number(this.toastDuration),
                fullWidth: this.isToastFullWidth,
            });
        },
        reqListPageChange() {
            this.findReqsData();
        },
        findData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: [
                    this.toolbar.formData.searchKey,
                    this.toolbar.formData.status,
                    this.toolbar.formData.licenseStatus,
                    this.toolbar.formData.applyType,
                ],
            };
            this.$api.licenseManageAPI
                .getLicenseList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableData = res.data.Data.dataTable;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.tableHeight = this.$calTableHeight(
                        res.data.Data.dataTable.length
                    );
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        selectReqs() {
            this.findReqsData();
            this.isShowRequireSel = true;
        },
        findReqsData() {
            const findStat = "2"; //全部
            const devEmail = this.$store.state.email;
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.reqTablePager.currentPage,
                pageSize: this.reqTablePager.pageSize,
                searchKey: [
                    this.reqTablePager.searchKey,
                    findStat,
                    "5",
                    devEmail,
                ], //第4个参数，是按开发人员查询
            };
            this.$api.requireManageAPI
                .getRequireList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.dtReqs = res.data.Data.dataTable;
                    this.reqTablePager.currentPage = res.data.Data.currentPage;
                    this.reqTablePager.pageSize = res.data.Data.pageSize;
                    this.reqTablePager.totalResult = res.data.Data.totalResult;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        confirmSelectReq() {
            const $table = this.$refs.xTableReqs;
            const record = $table.getCurrentRecord();
            if (record == null || record.length == 0) {
                VXETable.modal.message({
                    content: "请选择一行数据",
                    status: "info",
                });
                return;
            }
            this.formInput.formData.ReqID = record.Id;
            this.formInput.formData.processName = record.processName;
            this.formInput.formData.requireNo = record.requireNo;
            this.formInput.formData.singleTimeUse = record.manSingleTime;
            this.formInput.formData.frequency = record.manFrequency;
            this.formInput.formData.participate = 0;
            this.formInput.formData.yearTimeUse = record.manYear;
            this.formInput.formData.leaderEmail = record.leaderEmail;
            this.formInput.formData.leader = record.leader;

            this.isShowRequireSel = false;
        },
        calTableHeight(rowsLength) {
            let minHeight = window.innerHeight - (65 + 28 + 198);
            let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
            this.tableHeight = Math.max(minHeight, calHeight);
        },
        addLicenseMore: async function () {
            this.formInput.formData = {
                Id: this.$utils.guid(),
                userName: this.$store.state.userName,
                emailEx: this.$store.state.email,
                jobNumber: "",
                headQuarter: this.$store.state.jobZb, //总部
                dept: this.$store.state.jobName, //部门
                office: "", //科室
                flowName: "",
                planFinishTime: "",
                applyMonth: "",
                sceneDesc: "",
                singleTimeUse: "",
                frequency: "",
                participate: "",
                yearTimeUse: "",
                leader: "",
                leaderEmail: "",
                status: "",
                applyType: "1", //首次申请
            };
            this.editType = "1"; //新增
            this.formInput.allInputDisable = false;
            this.formInput.saveButDisable = false;

            this.formInput.isShow = true;

            const $rForm = this.$refs.rForm;
            try {
                const re = await $rForm.clearValidate();
            } catch (e) {
                console.log(e);
            }
        },
        //新增
        async addLicense() {
            //this.showPopup = true;
            // 普通业务不能申请，管理员可以申请
            if (this.$store.state.isAdmin == "0") {
                this.showPopup = true;
                return;
            }
            this.addLicenseMore();

            // const params = {
            //     uid: this.$store.state.userID,
            //     email: this.$store.state.email,
            //     currentPage: this.tablePager.currentPage,
            //     pageSize: this.tablePager.pageSize,
            //     searchKey: [
            //         this.$store.state.isAdmin == "1"
            //             ? "iamadmin"
            //             : this.$store.state.email,
            //         "",
            //         "生效中",
            //         "",
            //     ],
            // };
            // //查询是否有生效中的许可
            // this.$api.licenseManageAPI
            //     .getLicenseList(Qs.stringify(params))
            //     .then((res) => {
            //         if (res.data.Success == false) {
            //             VXETable.modal.alert({
            //                 content: res.data.Message,
            //                 status: "error",
            //             });
            //             return;
            //         }

            //         if (res.data.Data.dataTable.length > 0) {
            //             VXETable.modal.alert({
            //                 content: "当前已存在生效中的许可，不能再次申请",
            //                 status: "error",
            //             });
            //         } else {
            //             this.addLicenseMore();
            //         }
            //     })
            //     .catch((error) => {
            //         console.log(error);
            //     });
            //查询结束
        },
        //延期申请
        async moreLicense() {
            const $table = this.$refs.xTable;
            const record = $table.getCurrentRecord();
            if (record == null || record.length == 0) {
                VXETable.modal.message({
                    content: "请选择一行数据",
                    status: "info",
                });
                return;
            }
            const data = {
                licenseId: record.Id,
                userId: this.$store.state.userID,
            };

            this.$api.licenseManageAPI
                .moreLicense(Qs.stringify(data))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.alert({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    VXETable.modal.message({
                        content: "生成延期申请成功，请修改后提交审核",
                        status: "success",
                    });
                    this.findData();
                })
                .catch((error) => {
                    VXETable.modal.alert({ content: error, status: "error" });
                    console.log(error);
                });
        },
        //保存资产
        async save() {
            const $rForm = this.$refs.rForm;
            const formErrMap = await $rForm.validate();
            if (formErrMap) {
                return;
            }

            // let publishCount = await this.getReqPublishCount();
            // console.log("publishCount", publishCount);
            // if (publishCount == 0) {
            //     this.showPopup = true;
            //     return;
            // }

            const data = this.formInput.formData;
            //新增
            if (this.editType === "1") {
                this.$api.licenseManageAPI
                    .addLicense(Qs.stringify(data))
                    .then((res) => {
                        if (res.data.Success == false) {
                            VXETable.modal.alert({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        this.editType = "2"; //新增后是修改

                        VXETable.modal.message({
                            content: "保存成功",
                            status: "success",
                        });
                    })
                    .catch((error) => {
                        VXETable.modal.alert({
                            content: error,
                            status: "error",
                        });
                        console.log(error);
                    });
            } else if (this.editType === "2") {
                //更新
                this.$api.licenseManageAPI
                    .updateLicense(Qs.stringify(data))
                    .then((res) => {
                        if (res.data.Success == false) {
                            VXETable.modal.alert({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }

                        VXETable.modal.message({
                            content: "保存成功",
                            status: "success",
                        });
                    })
                    .catch((error) => {
                        VXETable.modal.message({
                            content: error,
                            status: "error",
                        });
                        console.log(error);
                    });
            }
        },
        //提交
        async submit() {
            const $rForm = this.$refs.rForm;
            const formErrMap = await $rForm.validate();
            if (formErrMap) {
                this.submitLoading = false;
                return;
            }
            // let publishCount = await this.getReqPublishCount();
            // if (publishCount == 0) {
            //     this.showPopup = true;
            //     return;
            // }
            const type = await VXETable.modal.confirm("您确定要提交该数据吗?");
            const $grid = this.$refs.xTable1;
            if (type === "confirm") {
                const data = this.formInput.formData;
                this.submitLoading = true;
                this.$api.licenseManageAPI
                    .submitLicense(Qs.stringify(data))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            this.submitLoading = false;
                            return;
                        }
                        VXETable.modal.message({
                            content: "提交成功",
                            status: "success",
                        });
                        this.findData();
                        this.getLicenseCount();
                        this.addAuditRecord("0"); //写审核日志
                        this.formInput.isShow = false;
                        this.submitLoading = false;
                        this.licenseDetail.RPAUser = res.data.Data.RPAUser;
                        this.licenseDetail.RPAPwd = res.data.Data.RPAPwd;
                        this.licenseDetail.isShow = true;
                    })
                    .catch((error) => {
                        VXETable.modal.message({
                            content: error,
                            status: "error",
                        });
                        this.submitLoading = false;
                        console.log(error);
                    });
            }
        },
        //删除
        async removeEvent(row) {
            if (row.statusName === "已通过" || row.statusName === "审批中") {
                await VXETable.modal.message({
                    content: "审批中或已通过不能删除，请先驳回",
                    status: "error",
                });
                return;
            }
            const type = await VXETable.modal.confirm("您确定要删除该数据?");
            const $grid = this.$refs.xTable;
            if (type === "confirm") {
                this.$api.licenseManageAPI
                    .delLicense(Qs.stringify({ licenseId: row.Id }))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }

                        VXETable.modal.message({
                            content: "删除成功",
                            status: "success",
                        });
                        $grid.remove(row);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        //编辑数据
        editEvent(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 0,
                pageSize: 0,
                searchKey: [row.Id],
            };
            this.$api.licenseManageAPI
                .getOneLicense(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.formInput.formData = res.data.Data;
                    this.formInput.formData.applyMonth =
                        this.formInput.formData.applyMonth.toString();
                    if (
                        this.formInput.formData.status == "0" ||
                        this.formInput.formData.status == "3"
                    ) {
                        this.formInput.title = "编辑许可申请";
                        this.formInput.saveButDisable = false;
                        this.formInput.allInputDisable = false;
                    } else {
                        this.formInput.title = "查看许可申请";
                        this.formInput.saveButDisable = true;
                        this.formInput.allInputDisable = true;
                    }

                    this.editType = "2"; //更新

                    this.formInput.isShow = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        showEvent(row) {
            this.licenseDetail.RPAUser = row.RPAUser;
            this.licenseDetail.RPAPwd = row.RPAPwd;
            this.licenseDetail.isShow = true;
        },
        //停止许可
        async stopEvent(row) {
            if (row.licenseStatus != "生效中") {
                await VXETable.modal.message({
                    content: "许可未生效，不能停用许可",
                    status: "error",
                });
                return;
            }
            const type = await VXETable.modal.confirm("您确定要停用该数据?");
            const $grid = this.$refs.xTable;
            if (type === "confirm") {
                this.$api.licenseManageAPI
                    .stopLicense(
                        Qs.stringify({
                            licenseId: row.Id,
                            userId: this.$store.state.userID,
                        })
                    )
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }

                        VXETable.modal.message({
                            content: "停用成功",
                            status: "success",
                        });
                        this.findData();
                        this.getLicenseCount();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        //启动许可
        async startEvent(row) {
            if (row.licenseStatus === "生效中") {
                await VXETable.modal.message({
                    content: "许可生效中，不能重复启用",
                    status: "error",
                });
                return;
            }
            const type = await VXETable.modal.confirm("您确定要启用该数据?");
            const $grid = this.$refs.xTable;
            if (type === "confirm") {
                this.$api.licenseManageAPI
                    .startLicense(
                        Qs.stringify({
                            licenseId: row.Id,
                            userId: this.$store.state.userID,
                        })
                    )
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        VXETable.modal.message({
                            content: "启用成功",
                            status: "success",
                        });
                        this.findData();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        addAuditRecord(status) {
            //写审核日志
            const params = {
                auditBuId: this.formInput.formData.Id,
                auditMan: this.$store.state.userName,
                auditManUid: this.$store.state.userID,
                auditStatus: status, //0发起 1 通过 2 驳回
                auditOpinion: "",
                auditNode: "审核发起",
            };
            this.$api.requireManageAPI
                .addAuditRecord(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getLicenseCount() {
            this.$api.licenseManageAPI
                .getLicenseCount()
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.licenseInfo.AllCount = res.data.Data.AllCount;
                    this.licenseInfo.UsedCount = res.data.Data.UsedCount;
                    this.licenseInfo.RemainCount = res.data.Data.RemainCount;
                    this.licenseInfo.AllCount2 = res.data.Data.AllCount2;
                    this.licenseInfo.UsedCount2 = res.data.Data.UsedCount2;
                    this.licenseInfo.RemainCount2 = res.data.Data.RemainCount2;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getUiPathPublishCount() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: "",
                pageSize: "",
                searchKey: [""],
            };
            this.$api.newPublishManageAPI
                .getUiPathPublishCount(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.publishCount = res.data.Data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async getReqPublishCount() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: "",
                pageSize: "",
                searchKey: [this.formInput.formData.requireNo],
            };
            const res =
                await this.$api.newPublishManageAPI.getUiPathPublishCount(
                    Qs.stringify(params)
                );

            if (!res.data.Success) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return null;
            }

            return res.data.Data;
        },
        closeWinEvent() {
            this.findData();
        },
        calYearUse() {
            this.formInput.formData.yearTimeUse = (
                this.formInput.formData.singleTimeUse *
                this.formInput.formData.frequency *
                this.formInput.formData.participate *
                12
            ).toFixed(2);
        },
        showAuditList(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 1,
                searchKey: [row.Id], //
            };
            this.$api.requireManageAPI
                .getAuditRecordList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.dtAudit = res.data.Data;
                    this.isShowAuditList = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindStatus() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: "",
                pageSize: "",
                searchKey: ["6"],
            };
            this.$api.systemManageAPI
                .getLookupValue(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.toolbar.statusOptions = [];
                    for (const item of res.data.Data) {
                        this.toolbar.statusOptions.push({
                            value: item.LookupValueCode,
                            label: item.LookupValueName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        handlePageChange() {
            this.findData();
        },
        clear() {
            this.toolbar.formData.searchKey = "";
            this.toolbar.formData.status = "";
            this.toolbar.formData.applyType = "";
            this.toolbar.formData.licenseStatus = "";
        },
        keydown(e) {
            if (e.keyCode === 13) {
                this.findData();
            }
        },
        copyUser() {
            navigator.clipboard
                .writeText(this.licenseDetail.RPAUser)
                .then(function () {
                    VXETable.modal.message({
                        content: "账号已复制",
                        status: "success",
                    });
                })
                .catch(function (err) {
                    console.error("复制文本失败: ", err);
                });
        },
        copyPwd() {
            navigator.clipboard
                .writeText(this.licenseDetail.RPAPwd)
                .then(function () {
                    VXETable.modal.message({
                        content: "密码已复制",
                        status: "success",
                    });
                })
                .catch(function (err) {
                    console.error("复制文本失败: ", err);
                });
        },
    },
    created() {
        this.isShowEditRow = this.$store.state.isAdmin === "1";
    },
    mounted() {
        this.bindStatus();
        this.findData();
        this.getLicenseCount();
        // this.getUiPathPublishCount();
        window.addEventListener("keydown", this.keydown);
    },
    unmounted() {
        window.removeEventListener("keydown", this.keydown, false);
    },
};
</script>

<style scoped>
.active {
    color: green;
}

.error {
    color: red;
}

.audit {
    color: blue;
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
